import React from "react";
import { Box, Button } from "@mui/joy";

interface ScheduleMeetingButtonProps {
  selectedApplicantIds: string[];
  onClick: () => void;
}

const ScheduleMeetingButton: React.FC<ScheduleMeetingButtonProps> = ({ selectedApplicantIds, onClick }) => {
  if (selectedApplicantIds.length === 0) return null;
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        borderRadius: '12px',
        p: 2,
        mb: {xs: 0, md: 2},
        maxWidth: 'sm',
        mx: 'auto'
      }}
    >
      <Button
        variant="solid"
        size="lg"
        fullWidth
        onClick={onClick}
        sx={{
          backgroundColor: '#2e2d7e',
          '&:hover': {
            backgroundColor: '#23225f'
          },
          height: 56,
          fontSize: '18px',
          fontWeight: 600,
          borderRadius: '12px',
        }}
      >
        Schedule Meeting
      </Button>
    </Box>
  );
};

export default ScheduleMeetingButton; 